import { httpClient } from "@/app/shared/shared-services/httpClient";
import { environment } from "@/environment";

const URL = environment.loyaltyApiBaseUrl;

export default {
  async fetchTiers(query) {
    const url = `${URL}v1/tiers${query}`;
    return (await httpClient.get(url)).data;
  },
  async createTier(tier) {
    const url = `${URL}v1/tiers`;
    return await httpClient.post(url, tier);
  },
  async updateTier(tier) {
    const url = `${URL}v1/tiers/${tier.id}`;
    return await httpClient.put(url, tier);
  },
  async removeTier(tierId) {
    const url = `${URL}v1/tiers/${tierId}`;
    return await httpClient.delete(url);
  },
};
